import { render, staticRenderFns } from "./NewUserEdit.vue?vue&type=template&id=cb808f2c&"
import script from "./NewUserEdit.vue?vue&type=script&lang=js&"
export * from "./NewUserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports